export default {"src":"/_next/static/media/logo_noord.6e18eb14.svg","height":39,"width":127,"blurWidth":0,"blurHeight":0};